// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container-wrapper {
  display: flex;
  justify-content: center; /* Align the tabs to the right */
}

.tabs-containerss .nav-tabs .nav-item.show .nav-link,
.tabs-containerss .nav-tabs .nav-link.active {
  color: #ff4817;
  background-color: transparent;
  border-bottom: 4px solid #ff4817;
}

.tabs-containerss .nav-tabs {
  display: flex;
  justify-content: flex-end; /* Align the tabs to the right */
  width: 100%;
}

.tabs-containerss .nav-tabs .nav-link {
  border: 0px solid transparent;
  color: #000;
  background-color: transparent;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.tab-title i {
  color: #ff4817;
  font-size: 24px;
}

.tab-title .ml-2 {
  margin-left: 8px;
}

/* .content {
    margin-top: 20px; /* Adjust as necessary */
/*} */

body {
  margin: 0;
  padding: 0;
}

.testimonials-part {
  background-color: #ffede8;
  padding: 4rem 0;
}
.payment-physio-section {
  background-color: #ffede8;
  padding-top: 1rem;
  padding-bottom:1rem;
}
.split-heading {
  display: flex;
  flex-direction: column;
}
.faqs-section {
  padding: 4rem 0;
}
.include-section {
  padding-bottom: 4rem;
}

.physiotherapist {
  background: linear-gradient(to top, #ffffff 50%, #ffede8 50%);
}

/* payment-physio-section */
.payment-physio-section,
.testimonials-title-section {
  display: flex;
  text-align: center;
}

.title-part {
  padding: 10px 0;
  max-width: 60%;
  margin: auto;
  color: var(--black);
}

.title-part h3 {
  font-size: 30px;
  font-weight: 600;
  margin-top: 20px;
}

.title-part h4,
.title-part-best h2 {
  font-size: 42px;
  font-weight: 700;
}
.fw-bolder {
  font-size: 42px;
}

/* .testimonial-content  */
.testimonials-section {
  background-color: var(--white);
  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: center;
  height: auto;
}

.doctor-physio-button-container {
  display: flex;
  align-items: center;
  width: 272px;
  height: 61px;
  padding-left: 8px;
  background: rgba(255, 72, 23, 0.1);
  border-radius: 37px;
}

.doctor-physio-button {
  min-width: 256px;
  height: 45px;
  font-weight: 600;
  font-size: 18px;
  background: white;
  border: none;
  border-radius: 22px;
}

.payment-part-month {
  font-size: 20px;
  font-weight: 400;
}
/* include-section */
/* .include-allcontent-section {
  margin-left: 107px;
} */
.include-title-text {
  font: 600 24px/33px Poppins, sans-serif;
  display: flex;
  justify-content: center;
}
.include-list-container {
  margin-top: 20px;
}

.exercise-description {
  font: 600 16px/22.5px Poppins, sans-serif;
}
.include-content-section {
  display: flex;
  justify-content: start;
}
.include-description-container {
  width: 26px;
  height: 26px;
}
.include-description-text-block {
  margin-left: 9px;
  font: 400 16px Poppins, sans-serif;
}
.sales-team-contact-info {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.friendly-sales-team-text-style {
  font: 400 16px/20px Poppins, sans-serif;
  padding-right: 5px;
}
.protocol-count-text-style {
  font: 600 16px/20px Poppins, sans-serif;
}
/* faqs-section */
.faqs-all-content-section {
  display: flex;
  align-items: center;
}
/* .accordion .accordion-item {
      background-color: transparent;
      border: 0;
    } */

/* .accordion .accordion-item .accordion-header {
      border-radius: 14px;
      border: 0;
      background-color: #ffede8;
      padding-bottom: 10px;
    } */

/* .accordion .accordion-item .accordion-button {
      padding: 0;
      color: var(--black);
      font-size: 18px;
      font-weight: 600;
      background-color: transparent;
      border: 0;
      box-shadow: none;
    }
    .accordion-body {
      padding-left: 15px;
      padding-bottom: 10px;
    }
    .accordion-button::after {
      color: var(--primary);
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background-position: center;
      background-size: 14px;
      border: 2px solid #ff4817;
      background-image: url(../../src/assets/images/down.png);
    }
    .accordion-button:not(.collapsed)::after {
      background-image: url(../../src/assets/images/down.png);
      transform: var(--bs-accordion-btn-icon-transform);
    }
     */
ol {
  list-style-type: none;
}

.dotted1,
.dotted2,
.dotted3 {
  position: relative;
  margin: 0;
  padding-bottom: 1em;
  padding-left: 35px;
}

.dotted1:before {
  content: "";
  position: absolute;
  left: -3px;
  height: 20px;
  width: 20px;
  background-color: #ff4817;
  border-radius: 50%;
}
.dotted2:before,
.dotted3:before {
  content: "";
  position: absolute;
  left: -3px;
  height: 20px;
  width: 20px;
  background-color: #ffc4b4;
  border-radius: 50%;
}

.dotted1:after {
  content: "";
  background-color: #ffc4b4;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 6px;
  width: 3px;
  margin-top: 20px;
}
.dotted2:after {
  content: "";
  background-color: #ffc4b4;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 6px;
  width: 3px;
}
/* button section   */

.subscription-plan-selector {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}
.monthly-button {
  min-width: 125px;
  height: 44px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: white;
  cursor: pointer;
  border: 1px solid #ff7049;
  border-radius: 22px;
  background-color: #ff7049;
}
.quarterly-button,
.yearly-button {
  min-width: 125px;
  height: 44px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  border: 1px solid #ff7049;
  border-radius: 22px;
  background-color: transparent;
  color: #ff7049;
}
.quarterly-button:hover,
.yearly-button:hover {
  min-width: 125px;
  height: 44px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: white;
  cursor: pointer;
  border: 1px solid #ff7049;
  border-radius: 22px;
  background-color: #ff7049;
}

.pricing-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 25%;
  background: #fffaf8;
  border: 2px solid #ff653b;
  border-radius: 10px;
}
.price-container {
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  padding-bottom: 15px;
}
.price-strike-through {
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  color: rgba(92, 92, 92, 0.5);
  text-decoration-line: line-through;
}

.price-highlighted-text {
  margin: 0;
  font-weight: 700;
  font-size: 60px;
  line-height: 74px;
  color: #ff6036;
}
.monthly-price-label {
  margin: 0;
  margin-top: -12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #ff6036;
}
.promo-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: #ff4c1c;
  border-radius: 0px 0px 7px 7px;
}
.promo-banner-text-style {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: white;
}

@media screen and (max-width: 1024px) {
}

@media screen and (max-width: 991px) {
  /* .accordion, */
  .title-part {
    max-width: 100%;
  }

  .title-part h3 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 20px;
  }
}

@media screen and (max-width: 768px) {
  .nav-tabs .nav-link,
  .product-section .product-card p,
  .title-part p {
    font-size: 14px;
  }

  .title-part h3 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 20px;
  }

  .title-switches-container {
    display: block;
  }

  .testimonials-section {
    grid-template-columns: 1fr;
    gap: 42px;
  }

  .small-image {
    max-width: 100%;
    max-height: none;
    border-radius: 14px 14px 0 0;
  }
  .pricing-container {
    width: 30%;
  }
  .promo-banner-text-style {
    font-size: 14px;
  }
  .price-highlighted-text {
    font-size: 50px;
    margin-top: -10px;
  }
  .monthly-price-label {
    font-size: 16px;
  }
  .price-strike-through {
    font-size: 22px;
    line-height: 20px;
  }
  .price-container {
    padding-top: 12px;
    padding-bottom: 5px;
  }
}

@media (max-width: 574px) {
  .payment-physio-section {
    padding: 0px;
  }

  .testimonials-part {
    padding: 2rem 0;
  }

  .highlight-discount-price {
    font-size: 20px;
  }

  .payment-part-month {
    font-size: 16px;
  }

  .strike-through-text {
    font-size: 16px;
  }
  .include-allcontent-section {
    margin: auto;
  }
  .faqs-all-content-section {
    display: block !important;
  }
  .include-description-container {
    width: 16px !important;
    height: 16px !important;
  }
  .include-description-text-block {
    font-size: 14px !important;
  }
  .include-section {
    padding-bottom: 2rem;
  }
  .faqs-section {
    padding-top: 2rem;
    padding-bottom: 0px;
  }
  /* .accordion .accordion-item .accordion-button {
      font-size: 16px !important;
    }
    .accordion-body {
      font-size: 14px;
      padding-bottom: 5px !important;
      padding-left: 12px !important;
      padding-top: 0px;
    }
    .accordion-button::after {
      width: 24px !important;
      height: 24px !important;
    } */

  .dotted1:before,
  .dotted2:before,
  .dotted3:before,
  .dotted1::after,
  .dotted2::after,
  .dotted3::after {
    display: none;
  }
  .dotted1,
  .dotted2,
  .dotted3 {
    padding-left: 0px !important;
  }
  .dotted1 {
    padding-top: 20px !important;
  }
  ol {
    padding-left: 5px !important;
    margin-bottom: 0px !important;
  }
  .fw-bolder {
    font-size: 24px;
  }
  .include-title-part {
    justify-items: center;
  }
  .subscription-plan-selector {
    gap: 12px;
  }
  .monthly-button {
    min-width: 85px;
    height: 40px;
    font-size: 14px;
  }
  .quarterly-button,
  .yearly-button {
    min-width: 85px;
    height: 40px;
    font-size: 14px;
  }
  .pricing-container {
    width: 100%;
  }
  .price-container {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .price-strike-through {
    font-size: 20px;
    line-height: 20px;
  }

  .price-highlighted-text {
    margin-top: -5px;
    font-size: 48px;
  }
  .monthly-price-label {
    font-size: 14px;
  }
  .promo-banner {
    height: 30px;
  }
  .promo-banner-text-style {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/payment.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB,EAAE,gCAAgC;AAC3D;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;8CAC8C;AAC9C,KAAK;;AAEL;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,oBAAoB;AACpB;;GAEG;AACH;EACE,uCAAuC;EACvC,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,uCAAuC;AACzC;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;;OAGO;;AAEP;;;;;OAKO;;AAEP;;;;;;;;;;;;;;;;;;;;;;;;;;;MA2BM;AACN;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;AACZ;AACA,qBAAqB;;AAErB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;;;;;;;;;;;;OAYK;;EAEL;;;;;;IAME,aAAa;EACf;EACA;;;IAGE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".tabs-container-wrapper {\n  display: flex;\n  justify-content: center; /* Align the tabs to the right */\n}\n\n.tabs-containerss .nav-tabs .nav-item.show .nav-link,\n.tabs-containerss .nav-tabs .nav-link.active {\n  color: #ff4817;\n  background-color: transparent;\n  border-bottom: 4px solid #ff4817;\n}\n\n.tabs-containerss .nav-tabs {\n  display: flex;\n  justify-content: flex-end; /* Align the tabs to the right */\n  width: 100%;\n}\n\n.tabs-containerss .nav-tabs .nav-link {\n  border: 0px solid transparent;\n  color: #000;\n  background-color: transparent;\n  font-size: 16px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.tab-title i {\n  color: #ff4817;\n  font-size: 24px;\n}\n\n.tab-title .ml-2 {\n  margin-left: 8px;\n}\n\n/* .content {\n    margin-top: 20px; /* Adjust as necessary */\n/*} */\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.testimonials-part {\n  background-color: #ffede8;\n  padding: 4rem 0;\n}\n.payment-physio-section {\n  background-color: #ffede8;\n  padding-top: 1rem;\n  padding-bottom:1rem;\n}\n.split-heading {\n  display: flex;\n  flex-direction: column;\n}\n.faqs-section {\n  padding: 4rem 0;\n}\n.include-section {\n  padding-bottom: 4rem;\n}\n\n.physiotherapist {\n  background: linear-gradient(to top, #ffffff 50%, #ffede8 50%);\n}\n\n/* payment-physio-section */\n.payment-physio-section,\n.testimonials-title-section {\n  display: flex;\n  text-align: center;\n}\n\n.title-part {\n  padding: 10px 0;\n  max-width: 60%;\n  margin: auto;\n  color: var(--black);\n}\n\n.title-part h3 {\n  font-size: 30px;\n  font-weight: 600;\n  margin-top: 20px;\n}\n\n.title-part h4,\n.title-part-best h2 {\n  font-size: 42px;\n  font-weight: 700;\n}\n.fw-bolder {\n  font-size: 42px;\n}\n\n/* .testimonial-content  */\n.testimonials-section {\n  background-color: var(--white);\n  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 14px;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  align-items: center;\n  height: auto;\n}\n\n.doctor-physio-button-container {\n  display: flex;\n  align-items: center;\n  width: 272px;\n  height: 61px;\n  padding-left: 8px;\n  background: rgba(255, 72, 23, 0.1);\n  border-radius: 37px;\n}\n\n.doctor-physio-button {\n  min-width: 256px;\n  height: 45px;\n  font-weight: 600;\n  font-size: 18px;\n  background: white;\n  border: none;\n  border-radius: 22px;\n}\n\n.payment-part-month {\n  font-size: 20px;\n  font-weight: 400;\n}\n/* include-section */\n/* .include-allcontent-section {\n  margin-left: 107px;\n} */\n.include-title-text {\n  font: 600 24px/33px Poppins, sans-serif;\n  display: flex;\n  justify-content: center;\n}\n.include-list-container {\n  margin-top: 20px;\n}\n\n.exercise-description {\n  font: 600 16px/22.5px Poppins, sans-serif;\n}\n.include-content-section {\n  display: flex;\n  justify-content: start;\n}\n.include-description-container {\n  width: 26px;\n  height: 26px;\n}\n.include-description-text-block {\n  margin-left: 9px;\n  font: 400 16px Poppins, sans-serif;\n}\n.sales-team-contact-info {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n.friendly-sales-team-text-style {\n  font: 400 16px/20px Poppins, sans-serif;\n  padding-right: 5px;\n}\n.protocol-count-text-style {\n  font: 600 16px/20px Poppins, sans-serif;\n}\n/* faqs-section */\n.faqs-all-content-section {\n  display: flex;\n  align-items: center;\n}\n/* .accordion .accordion-item {\n      background-color: transparent;\n      border: 0;\n    } */\n\n/* .accordion .accordion-item .accordion-header {\n      border-radius: 14px;\n      border: 0;\n      background-color: #ffede8;\n      padding-bottom: 10px;\n    } */\n\n/* .accordion .accordion-item .accordion-button {\n      padding: 0;\n      color: var(--black);\n      font-size: 18px;\n      font-weight: 600;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none;\n    }\n    .accordion-body {\n      padding-left: 15px;\n      padding-bottom: 10px;\n    }\n    .accordion-button::after {\n      color: var(--primary);\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      background-position: center;\n      background-size: 14px;\n      border: 2px solid #ff4817;\n      background-image: url(../../src/assets/images/down.png);\n    }\n    .accordion-button:not(.collapsed)::after {\n      background-image: url(../../src/assets/images/down.png);\n      transform: var(--bs-accordion-btn-icon-transform);\n    }\n     */\nol {\n  list-style-type: none;\n}\n\n.dotted1,\n.dotted2,\n.dotted3 {\n  position: relative;\n  margin: 0;\n  padding-bottom: 1em;\n  padding-left: 35px;\n}\n\n.dotted1:before {\n  content: \"\";\n  position: absolute;\n  left: -3px;\n  height: 20px;\n  width: 20px;\n  background-color: #ff4817;\n  border-radius: 50%;\n}\n.dotted2:before,\n.dotted3:before {\n  content: \"\";\n  position: absolute;\n  left: -3px;\n  height: 20px;\n  width: 20px;\n  background-color: #ffc4b4;\n  border-radius: 50%;\n}\n\n.dotted1:after {\n  content: \"\";\n  background-color: #ffc4b4;\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 6px;\n  width: 3px;\n  margin-top: 20px;\n}\n.dotted2:after {\n  content: \"\";\n  background-color: #ffc4b4;\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 6px;\n  width: 3px;\n}\n/* button section   */\n\n.subscription-plan-selector {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-top: 20px;\n}\n.monthly-button {\n  min-width: 125px;\n  height: 44px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: white;\n  cursor: pointer;\n  border: 1px solid #ff7049;\n  border-radius: 22px;\n  background-color: #ff7049;\n}\n.quarterly-button,\n.yearly-button {\n  min-width: 125px;\n  height: 44px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  cursor: pointer;\n  border: 1px solid #ff7049;\n  border-radius: 22px;\n  background-color: transparent;\n  color: #ff7049;\n}\n.quarterly-button:hover,\n.yearly-button:hover {\n  min-width: 125px;\n  height: 44px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: white;\n  cursor: pointer;\n  border: 1px solid #ff7049;\n  border-radius: 22px;\n  background-color: #ff7049;\n}\n\n.pricing-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 25%;\n  background: #fffaf8;\n  border: 2px solid #ff653b;\n  border-radius: 10px;\n}\n.price-container {\n  display: flex;\n  flex-direction: column;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n.price-strike-through {\n  margin: 0;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 33px;\n  color: rgba(92, 92, 92, 0.5);\n  text-decoration-line: line-through;\n}\n\n.price-highlighted-text {\n  margin: 0;\n  font-weight: 700;\n  font-size: 60px;\n  line-height: 74px;\n  color: #ff6036;\n}\n.monthly-price-label {\n  margin: 0;\n  margin-top: -12px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n  color: #ff6036;\n}\n.promo-banner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  background: #ff4c1c;\n  border-radius: 0px 0px 7px 7px;\n}\n.promo-banner-text-style {\n  margin: 0;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 25px;\n  color: white;\n}\n\n@media screen and (max-width: 1024px) {\n}\n\n@media screen and (max-width: 991px) {\n  /* .accordion, */\n  .title-part {\n    max-width: 100%;\n  }\n\n  .title-part h3 {\n    font-size: 20px;\n    font-weight: 500;\n    margin-top: 20px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .nav-tabs .nav-link,\n  .product-section .product-card p,\n  .title-part p {\n    font-size: 14px;\n  }\n\n  .title-part h3 {\n    font-size: 20px;\n    font-weight: 500;\n    margin-top: 20px;\n  }\n\n  .title-switches-container {\n    display: block;\n  }\n\n  .testimonials-section {\n    grid-template-columns: 1fr;\n    gap: 42px;\n  }\n\n  .small-image {\n    max-width: 100%;\n    max-height: none;\n    border-radius: 14px 14px 0 0;\n  }\n  .pricing-container {\n    width: 30%;\n  }\n  .promo-banner-text-style {\n    font-size: 14px;\n  }\n  .price-highlighted-text {\n    font-size: 50px;\n    margin-top: -10px;\n  }\n  .monthly-price-label {\n    font-size: 16px;\n  }\n  .price-strike-through {\n    font-size: 22px;\n    line-height: 20px;\n  }\n  .price-container {\n    padding-top: 12px;\n    padding-bottom: 5px;\n  }\n}\n\n@media (max-width: 574px) {\n  .payment-physio-section {\n    padding: 0px;\n  }\n\n  .testimonials-part {\n    padding: 2rem 0;\n  }\n\n  .highlight-discount-price {\n    font-size: 20px;\n  }\n\n  .payment-part-month {\n    font-size: 16px;\n  }\n\n  .strike-through-text {\n    font-size: 16px;\n  }\n  .include-allcontent-section {\n    margin: auto;\n  }\n  .faqs-all-content-section {\n    display: block !important;\n  }\n  .include-description-container {\n    width: 16px !important;\n    height: 16px !important;\n  }\n  .include-description-text-block {\n    font-size: 14px !important;\n  }\n  .include-section {\n    padding-bottom: 2rem;\n  }\n  .faqs-section {\n    padding-top: 2rem;\n    padding-bottom: 0px;\n  }\n  /* .accordion .accordion-item .accordion-button {\n      font-size: 16px !important;\n    }\n    .accordion-body {\n      font-size: 14px;\n      padding-bottom: 5px !important;\n      padding-left: 12px !important;\n      padding-top: 0px;\n    }\n    .accordion-button::after {\n      width: 24px !important;\n      height: 24px !important;\n    } */\n\n  .dotted1:before,\n  .dotted2:before,\n  .dotted3:before,\n  .dotted1::after,\n  .dotted2::after,\n  .dotted3::after {\n    display: none;\n  }\n  .dotted1,\n  .dotted2,\n  .dotted3 {\n    padding-left: 0px !important;\n  }\n  .dotted1 {\n    padding-top: 20px !important;\n  }\n  ol {\n    padding-left: 5px !important;\n    margin-bottom: 0px !important;\n  }\n  .fw-bolder {\n    font-size: 24px;\n  }\n  .include-title-part {\n    justify-items: center;\n  }\n  .subscription-plan-selector {\n    gap: 12px;\n  }\n  .monthly-button {\n    min-width: 85px;\n    height: 40px;\n    font-size: 14px;\n  }\n  .quarterly-button,\n  .yearly-button {\n    min-width: 85px;\n    height: 40px;\n    font-size: 14px;\n  }\n  .pricing-container {\n    width: 100%;\n  }\n  .price-container {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .price-strike-through {\n    font-size: 20px;\n    line-height: 20px;\n  }\n\n  .price-highlighted-text {\n    margin-top: -5px;\n    font-size: 48px;\n  }\n  .monthly-price-label {\n    font-size: 14px;\n  }\n  .promo-banner {\n    height: 30px;\n  }\n  .promo-banner-text-style {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
